import * as React from 'react';

import moment from 'moment';
import 'moment-timezone';
import TimePicker from 'components/time_picker';
import DatePicker from 'components/date_picker';
import { DateTimePicker as AtlaskitDateTimePicker } from '@atlaskit/datetime-picker';

interface DateTimePickerState {
  date: moment.Moment;
}

interface DateTimePickerProps {
  timezone: string;
  timezoneDisplay: string;
  use_adg3_manage_style?: boolean;
}

export default class DateTimePicker extends React.PureComponent<
  DateTimePickerProps,
  DateTimePickerState
> {
  static defaultProps = {
    timezone: 'UTC',
    timezoneDisplay: 'UTC',
  };

  constructor(props: DateTimePickerProps) {
    super(props);
    const now = moment().tz(props.timezone);
    this.state = { date: now };
  }

  updateDate = (date: moment.Moment) => {
    this.setState({ date: date.tz(this.props.timezone) });
  };

  render() {
    return (
      <div className="date-time-picker-wrapper">
        {this.props.use_adg3_manage_style ? (
          <AtlaskitDateTimePicker
            onChange={this.updateDate}
            selectedDate={this.state.date}
            disabled={false}
            style={{
              width: '100%',
            }}
          />
        ) : (
          <div className="date-time-picker row">
            <div className="backfill-date-picker span6">
              <DatePicker
                onChange={this.updateDate}
                selectedDate={this.state.date}
                disabled={false}
              />
            </div>
            <div className="backfill-time-picker span6">
              <TimePicker
                onChange={this.updateDate}
                selectedDate={this.state.date}
                disabled={false}
              />
            </div>
          </div>
        )}
        <input
          type="hidden"
          name="incident[backfill_date]"
          value={this.state.date.toISOString()}
        />
      </div>
    );
  }
}
